import { render, staticRenderFns } from "./AddSupplierCostModal.vue?vue&type=template&id=2e7281de&"
import script from "./AddSupplierCostModal.vue?vue&type=script&lang=js&"
export * from "./AddSupplierCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports